module.exports = __webpack_public_path__ + "static/img/Weldon.ce4d349.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Weldon.jpg
// module id = MqYe
// module chunks = 0